import { createFileRoute } from '@tanstack/react-router';
import { PageHeader } from '@siliconx/shared/ui/PageHeader';
import { R2ControlsView } from '../components/r2/R2Controls';

/**
 * SIL-2383. Partner R2 controls (receipt counts, 5% erase sampling, DPR release, operator competency, untested-unit alert). Any member
 * reads and records receipts and sample results; admin-only controls are hidden for members and refused by the database functions.
 * Needs the SIL2383_R2_CONTROLS_ENABLED switch and the org's enrolment: while either is missing the page says the controls are not available.
 */
export const Route = createFileRoute('/r2-controls')({
  component: R2ControlsRoute,
});

function R2ControlsRoute() {
  return (
    <div className="space-y-6">
      <PageHeader title="R2 Controls" subtitle="Receipt counts, erase sampling, release approval and operator competency." pinTo="/r2-controls" />
      <R2ControlsView />
    </div>
  );
}
